import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { getRelationName } from '@/shared/components/RelationName';
import intlShape from '@/shared/utils/intlShape';
import DataCacheService from '@/shared/services/DataCacheService';
import config from '../../../config';
import api from '../../api';
import { dynamicSort } from '../../utils/dynamicSort';

const messages = defineMessages({
  NoOwnCompanyRelationsFound: 'No own company relations found',
  Relation: 'Relation',
});

export const getOwnCompanyRelations = () => {
  const endpoint = `${config.appUrls.api}/api/relation/names`;
  const params = {
    searchValue: '',
    take: 0,
    includeInactive: false,
    crmTypes: [4],
  };
  return api.base.get(endpoint, { params });
};

class OwnCompanyRelationSelect extends Component {
  state = {
    relations: null,
  };

  componentDidMount() {
    const { intl } = this.props;
    getOwnCompanyRelations().then(({ data }) => {
      const relations = data
        .map(item => ({
          key: item.id,
          label: getRelationName(intl, item),
          ...item,
        }))
        .sort(dynamicSort('label'));

      this.setState(
        {
          relations,
        },
        () => {
          const { value, onChange, userId } = this.props;
          if (!!value || relations.length === 0) return;
          if (relations.length === 1) {
            onChange(relations[0]);
          } else {
            const relationId = DataCacheService.getAbsenceRelationIdForUser(userId);
            const relation = relationId ? relations.find(x => x.id === relationId) : null;
            if (relation) {
              onChange(relation);
            } else {
              onChange(relations[0]);
            }
          }
        },
      );
    });
  }

  onSelect = e => {
    const { onChange } = this.props;
    const { relations } = this.state;
    const id = e.target.value || null;
    const relation = id ? relations.find(x => x.id === id) : null;
    onChange(relation);
  };

  render() {
    const { className, value, placeholder, intl, disabled, autoFocus } = this.props;
    const { relations } = this.state;

    if (relations === null) return null;
    if (!relations.length)
      return (
        <div className="form-control-static">
          <FormattedMessage {...messages.NoOwnCompanyRelationsFound} />
        </div>
      );
    const inputValue = (value && (value.id || value.key || value)) || '';
    return (
      <select
        className={classnames('form-control', className)}
        value={inputValue}
        onChange={this.onSelect}
        disabled={disabled}
        autoFocus={autoFocus}
      >
        {!inputValue && <option>{placeholder || intl.formatMessage(messages.Relation)}</option>}
        {relations.map(rel => (
          <option value={rel.id} key={rel.id}>
            {rel.label}
          </option>
        ))}
      </select>
    );
  }
}

OwnCompanyRelationSelect.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({ key: PropTypes.string.isRequired }), // Key/label
    PropTypes.shape({ id: PropTypes.string.isRequired }), // Id/Name
    PropTypes.string, // Id
  ]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.node,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  userId: PropTypes.string,
};
OwnCompanyRelationSelect.defaultProps = {
  value: null,
  onChange: () => {},
  className: null,
  placeholder: null,
  disabled: false,
  autoFocus: null,
  userId: undefined,
};
export default injectIntl(OwnCompanyRelationSelect);
